var map = {
	"./adobe.svg": 3374,
	"./amazon.svg": 1329,
	"./apple.svg": 5152,
	"./bluesky.svg": 9914,
	"./clearviewai.svg": 1157,
	"./common/aiOptOut-logo.svg": 9529,
	"./common/redact-back-arrow.svg": 3821,
	"./common/redact-flow-chart.svg": 6270,
	"./common/redact-icon.svg": 9963,
	"./common/redact-list-bullet.svg": 2581,
	"./common/redact-not-found.svg": 1215,
	"./common/redact-personal-content-icon.svg": 9459,
	"./common/redact-predictive-modeling-icon.svg": 5614,
	"./common/redact-reduce-privacy-icon.svg": 5320,
	"./common/redact-targeted-attacks-icon.svg": 5853,
	"./common/redacto-news-letter.svg": 271,
	"./common/redacto-space.svg": 747,
	"./common/redacto-woopsie.svg": 9590,
	"./dalle.svg": 7478,
	"./deviantart.svg": 3234,
	"./discord.svg": 9546,
	"./disqus.svg": 5003,
	"./figma.svg": 8132,
	"./flickr.svg": 3401,
	"./github.svg": 4527,
	"./gyazo.svg": 6178,
	"./imdb.svg": 6513,
	"./imgur.svg": 2381,
	"./instruction-images/amazon/instruction-1.png": 6305,
	"./instruction-images/amazon/instruction-2.png": 613,
	"./instruction-images/discord/instruction-1.png": 9037,
	"./instruction-images/discord/instruction-2.png": 7547,
	"./instruction-images/disqus/instruction-1.png": 565,
	"./instruction-images/imdb/instruction-1.png": 1942,
	"./instruction-images/imdb/instruction-2.png": 1177,
	"./instruction-images/imgur/instruction-1.png": 3553,
	"./instruction-images/imgur/instruction-2.png": 5824,
	"./instruction-images/linkedin/instruction-1.png": 8243,
	"./instruction-images/microsoft-office/instruction-1.png": 4200,
	"./instruction-images/microsoft-office/instruction-2.png": 8768,
	"./instruction-images/microsoft-office/instruction-3.png": 2968,
	"./instruction-images/microsoft-office/instruction-4.png": 4227,
	"./instruction-images/microsoft-teams/instruction-1.png": 3002,
	"./instruction-images/microsoft-teams/instruction-2.png": 4470,
	"./instruction-images/myanimelist/instruction-1.png": 4593,
	"./instruction-images/pinterest/instruction-1.png": 8216,
	"./instruction-images/pinterest/instruction-2.png": 7240,
	"./instruction-images/quora/instruction-1.png": 9739,
	"./instruction-images/reddit/instruction-1.png": 1007,
	"./instruction-images/reddit/instruction-2.png": 1367,
	"./instruction-images/skype/instruction-1.png": 7757,
	"./instruction-images/skype/instruction-2.png": 2647,
	"./instruction-images/spotify/instruction-1.png": 1114,
	"./instruction-images/spotify/instruction-2.png": 4544,
	"./instruction-images/squarespace/instruction-1.png": 7532,
	"./instruction-images/squarespace/instruction-2.png": 8731,
	"./instruction-images/squarespace/instruction-3.png": 3832,
	"./instruction-images/steam/instruction-1.png": 9444,
	"./instruction-images/tumblr/instruction-1.png": 4029,
	"./instruction-images/tumblr/instruction-2.png": 7666,
	"./instruction-images/twitter/instruction-1.png": 5877,
	"./instruction-images/twitter/instruction-2.png": 4737,
	"./instruction-images/twitter/instruction-3.png": 8371,
	"./instruction-images/twitter/instruction-4.png": 5333,
	"./instruction-images/wordpress/instruction-1.png": 6380,
	"./instruction-images/wordpress/instruction-2.png": 1872,
	"./linkedin.svg": 7608,
	"./medium.svg": 8594,
	"./meta.svg": 2513,
	"./microsoft-office.svg": 547,
	"./microsoft-teams.svg": 2607,
	"./microsoft.svg": 752,
	"./myanimelist.svg": 6295,
	"./pinterest.svg": 2909,
	"./quora.svg": 6903,
	"./reddit.svg": 1539,
	"./skype.svg": 9522,
	"./slack.svg": 2574,
	"./spotify.svg": 2929,
	"./squarespace.svg": 7065,
	"./stackoverflow.svg": 6007,
	"./steam.svg": 6432,
	"./tumblr.svg": 4264,
	"./twitter.svg": 1098,
	"./vimeo.svg": 8085,
	"./wordpress.svg": 9095,
	"./yelp.svg": 7468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4325;